import type * as Types from 'app/types/graphql';

import { VariantPriceSelectFragmentDoc } from '../fragments/variantPrice.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantPriceDuplicateMutationVariables = Types.Exact<{
  variantID: Types.Scalars['ID']['input'];
}>;

export type VariantPriceDuplicateMutationResponse = {
  variantPriceDuplicate: Pick<
    Types.VariantPrice,
    'id' | 'baseID' | 'handle' | 'status' | 'title' | 'redirectURL' | 'sourceProductBaseID'
  >;
};

export const VariantPriceDuplicateDocument = `
    mutation VariantPriceDuplicate($variantID: ID!) {
  variantPriceDuplicate(variantID: $variantID) {
    ...VariantPriceSelect
  }
}
    ${VariantPriceSelectFragmentDoc}`;

export const useVariantPriceDuplicateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantPriceDuplicateMutationResponse,
    TError,
    VariantPriceDuplicateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantPriceDuplicateMutationResponse,
    TError,
    VariantPriceDuplicateMutationVariables,
    TContext
  >(
    ['VariantPriceDuplicate'],
    (variables?: VariantPriceDuplicateMutationVariables) =>
      appFetcher<VariantPriceDuplicateMutationResponse, VariantPriceDuplicateMutationVariables>(
        VariantPriceDuplicateDocument,
        variables,
      )(),
    options,
  );
};

useVariantPriceDuplicateMutation.getKey = () => ['VariantPriceDuplicate'];
